export const ANALYTICS_EVENTS = {
  APP_OPEN_CLICK: 'app_open_click',
  APP_LANDING_VIEW_CLICK: 'app_landing_view_click',
  APP_PATH_SELECT: 'app_path_select',
  APP_PLAN_SELECT: 'app_plan_select',
  BOOK_OFFERING_SELECT: 'book_offering_select',
  BOOK_FORM_SUBMIT: 'book_form_submit',
  PARTNER_CLICK: 'partner_click',
};

export const ANALYTICS_PARAMS = {
  LOCATION: 'location',
  OUTBOUND: 'outbound',
  PATH: 'path',
  PLAN: 'plan',
};
